import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getAlertFrequencyTypes, getSavedListTypes, getSavedSearchTypes} from 'src/openapi/admin/apis/UserContentDictionariesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectAlertFrequencyTypes, selectSavedListTypes, selectSavedSearchTypes} from './services/dictionary-slice';

export const useAlertFrequencyTypes = () => {
    const apiDispatch = useAppDispatch();
    const alertFrequencyTypes = useSelector(selectAlertFrequencyTypes);

    const loadAlertFrequencyTypes = useCallback(() => {
        if (!alertFrequencyTypes.length) {
            apiDispatch(getAlertFrequencyTypes());
        }
    }, [alertFrequencyTypes.length, apiDispatch]);

    const getAlertFrequencyTypeByCode = useCallback((code: string) => {
        return alertFrequencyTypes?.find(e => e.code === code);
    }, [alertFrequencyTypes]);

    return {alertFrequencyTypes, loadAlertFrequencyTypes, getAlertFrequencyTypeByCode};
};

export const useSavedSearchTypes = () => {
    const apiDispatch = useAppDispatch();
    const savedSearchTypes = useSelector(selectSavedSearchTypes);

    const loadSavedSearchTypes = useCallback(() => {
        if (!savedSearchTypes.length) {
            apiDispatch(getSavedSearchTypes());
        }
    }, [savedSearchTypes.length, apiDispatch]);

    const getSavedSearchTypeByCode = useCallback((code: string) => {
        return savedSearchTypes?.find(e => e.code === code);
    }, [savedSearchTypes]);

    return {savedSearchTypes, loadSavedSearchTypes, getSavedSearchTypeByCode};
};

export const useSavedListTypes = () => {
    const apiDispatch = useAppDispatch();
    const savedListTypes = useSelector(selectSavedListTypes);

    const loadSavedListTypes = useCallback(() => {
        if (!savedListTypes.length) {
            apiDispatch(getSavedListTypes());
        }
    }, [savedListTypes.length, apiDispatch]);

    const getSavedListTypeByCode = useCallback((code: string) => {
        return savedListTypes?.find(e => e.code === code);
    }, [savedListTypes]);

    return {savedListTypes, loadSavedListTypes, getSavedListTypeByCode};
};
